import type { ServerContext } from '@/store/server-context';
import { NEW_CATEGORY_UIDS } from '@/app/(pages)/(category)/c/[slug]/constants';

export enum CategoryLayout {
    DEFAULT = 'default',
    NEW = 'new'
}

export const getCategoryLayout = (uid: string, serverContext: ServerContext): CategoryLayout => {
    if (NEW_CATEGORY_UIDS.includes(uid) && (serverContext.isAndroidWrapper || serverContext.isXsellWrapper)) {
        return CategoryLayout.NEW;
    }
    return CategoryLayout.DEFAULT;
};
